import styled from 'styled-components';

const ChipOption = styled.div`
  margin-bottom: ${({ theme }) => theme.size.spacing.medium.value};
  margin-right: ${({ theme }) => theme.size.spacing.medium.value};
`;

export { ChipOption };
